export const shadow = {
  dropdown: '0 5px 10px #00000040',
}
